<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Impressum</h3>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Angaben gemäß § 5 TMG</h4>
            <h5 class="description list">
              Podologiepraxis Boldt<br>
              Inhaber: Natalja Boldt<br>
              Hufelandstraße 14,<br>
              34537 Bad WIldungen<br>
              Deutschland<br>
              <br>
              <strong>Kontakt:</strong><br>
              Telefon: 05621 / 96 78 78 6<br>
              E-Mail: kontakt@podologie-boldt.de<br>
              <br>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br>
              Natalja Boldt
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Haftungsausschluss</h4>
            <h5 class="description list">
              Haftung für Inhalte<br>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.<br>
              <br>
              Haftung für Links<br>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.<br>
              <br>
              Urheberrecht<br>
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung oder Verbreitung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'privacy',
  bodyClass: 'privacy-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
